// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { gridThreeByThree16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-grid-three-by-three': IconGridThreeByThree;
    }
}

/**
 * The icon component for the 'gridThreeByThree' icon
 */
export class IconGridThreeByThree extends Icon {
    public constructor() {
        super(gridThreeByThree16X16);
    }
}

registerIcon('icon-grid-three-by-three', IconGridThreeByThree);
export const iconGridThreeByThreeTag = 'nimble-icon-grid-three-by-three';
